import { render, staticRenderFns } from "./BookmarkForm.vue?vue&type=template&id=4c3f13f0&scoped=true&"
import script from "./BookmarkForm.vue?vue&type=script&lang=js&"
export * from "./BookmarkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3f13f0",
  null
  
)

export default component.exports